// Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Styles
import styles from './styles.scss';

const SUSPENDED_AUTO_PAY_NOTIFICATION_MESSAGE = 'Your support plan has been suspended due to payment failure. Please update your payment method on file in the "Payment" area of My Account to reactivate your support plan';

const SuspendedAutoPayNotification = (props) => {
  const showNotification = props.isSuspended;
  return (
    showNotification ?
    (
      <div className={styles.container}>
        <p className={styles.notification}>
          <strong>{ SUSPENDED_AUTO_PAY_NOTIFICATION_MESSAGE }</strong>
        </p>
      </div>
    ) : null
  );
};

SuspendedAutoPayNotification.propTypes = {
  isSuspended: PropTypes.bool,
};

SuspendedAutoPayNotification.defaultProps = {
  isSuspended: false,
};

export default SuspendedAutoPayNotification;

/*
  SuspendedAutoPayNotification:
    A notification that displays when a customers auto-pay for a support plan has been suspended.
*/
